import Vue from "vue";
import Vuex from "vuex";
// https://github.com/paleo/direct-vuex
// https://itnext.io/use-a-vuex-store-with-typing-in-typescript-without-decorators-or-boilerplate-57732d175ff3
import { createDirectStore } from "direct-vuex";
import billingModule from "@/store/billingModule";
import invoiceModule from "@/store/invoiceModule";
import appModule from "@/store/appModule";

Vue.use(Vuex);

const {
  store,
  rootActionContext,
  moduleActionContext,
  rootGetterContext,
  moduleGetterContext
} = createDirectStore({
  modules: {
    billingModule,
    invoiceModule,
    appModule
  }
});

// Export the direct-store instead of the classic Vuex store.
export default store;

// The following exports will be used to enable types in the
// implementation of actions.
export {
  rootActionContext,
  moduleActionContext,
  rootGetterContext,
  moduleGetterContext
};

// The following lines enable types in the injected store '$store'.
export type AppStore = typeof store;
declare module "vuex" {
  interface Store<S> {
    direct: AppStore;
  }
}
